import { render } from "./SimpleGallery.vue?vue&type=template&id=caa142f2"
import script from "./SimpleGallery.vue?vue&type=script&lang=js"
export * from "./SimpleGallery.vue?vue&type=script&lang=js"

import "./SimpleGallery.vue?vue&type=style&index=0&id=caa142f2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__